import { UnifiedThemeProvider } from '@backstage/theme';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { RiMoonLine, RiSunLine } from '@remixicon/react';
import { verdantDarkTheme, verdantLightTheme } from './verdantTheme';

const verdantLight = ThemeBlueprint.make({
  name: 'light',
  params: {
    theme: {
      id: 'light',
      title: 'Light',
      variant: 'light',
      icon: <RiSunLine />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider
          theme={verdantLightTheme}
          themeName="verdant-light"
        >
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

const verdantDark = ThemeBlueprint.make({
  name: 'dark',
  params: {
    theme: {
      id: 'dark',
      title: 'Dark',
      variant: 'dark',
      icon: <RiMoonLine />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={verdantDarkTheme} themeName="verdant-dark">
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

export const verdantThemeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [verdantLight, verdantDark],
});
